/* eslint-disable */
/**
 * * This file was automatically generated by react-scripts-trackman codegen.
 * * DO NOT MODIFY IT BY HAND. Instead, modify endpoint definitions in backend,
 * * start backend to regenerate swagger.json, and run react-scripts-trackman codegen
 * * to regenerate this file.
 * *
 * * If you find errors in this file, do the following (in order):
 * * 1. Check Swagger configuration in backend (often SwaggerResponse is wrongly defined)
 * * 2. Check backend type and controller definitions
 * * 3. Check if the endpoint is properly defined in consumedEndpoints.json
 * * 4. Report the issue to react-scripts-trackman maintainers (mga@trackman.com)
 */

import {
  SeasonResponse,
  LookupLevelsQueryDto,
  LookupQueryResponse,
  LookupTeamsQueryDto,
  LookupDateRangeQueryDto,
  LookupUmpireSessionsQueryDto,
  LookupSessionsQueryResponse,
  LookupUmpiresQueryDto,
  LookupPlayersQueryDto,
  LookupSessionsQueryDto,
  SelectedItemDto,
} from '../types/CodegenLookupTypes';
import { AxiosInstance } from 'axios';
import { Result } from '../types/CodegenResult';

export class LookupService {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getLookupSeasons = async () => {
    const response = await this.axiosInstance.get<Result<SeasonResponse[]>>(`/api/v1/Lookup/seasons`);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postLookupLevels = async (requestBody: LookupLevelsQueryDto) => {
    const response = await this.axiosInstance.post<Result<LookupQueryResponse[]>>(`/api/v1/Lookup/levels`, requestBody);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postLookupBatterTeams = async (requestBody: LookupTeamsQueryDto) => {
    const response = await this.axiosInstance.post<Result<LookupQueryResponse[]>>(`/api/v1/Lookup/batter/teams`, requestBody);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postLookupPitcherTeams = async (requestBody: LookupTeamsQueryDto) => {
    const response = await this.axiosInstance.post<Result<LookupQueryResponse[]>>(`/api/v1/Lookup/pitcher/teams`, requestBody);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postLookupUmpireLeagues = async (requestBody: LookupDateRangeQueryDto) => {
    const response = await this.axiosInstance.post<Result<LookupQueryResponse[]>>(`/api/v1/Lookup/umpire/leagues`, requestBody);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postLookupUmpireSessions = async (requestBody: LookupUmpireSessionsQueryDto) => {
    const response = await this.axiosInstance.post<Result<LookupSessionsQueryResponse[]>>(`/api/v1/Lookup/umpire/sessions`, requestBody);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postLookupUmpires = async (requestBody: LookupUmpiresQueryDto) => {
    const response = await this.axiosInstance.post<Result<LookupQueryResponse[]>>(`/api/v1/Lookup/umpires`, requestBody);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postLookupBatters = async (requestBody: LookupPlayersQueryDto) => {
    const response = await this.axiosInstance.post<Result<LookupQueryResponse[]>>(`/api/v1/Lookup/batters`, requestBody);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postLookupPitchers = async (requestBody: LookupPlayersQueryDto) => {
    const response = await this.axiosInstance.post<Result<LookupQueryResponse[]>>(`/api/v1/Lookup/pitchers`, requestBody);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postLookupBatterSessions = async (requestBody: LookupSessionsQueryDto) => {
    const response = await this.axiosInstance.post<Result<LookupSessionsQueryResponse[]>>(`/api/v1/Lookup/batter/sessions`, requestBody);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postLookupPitcherSessions = async (requestBody: LookupSessionsQueryDto) => {
    const response = await this.axiosInstance.post<Result<LookupSessionsQueryResponse[]>>(`/api/v1/Lookup/pitcher/sessions`, requestBody);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getLookupGameTypes = async () => {
    const response = await this.axiosInstance.get<Result<SelectedItemDto[]>>(`/api/v1/Lookup/gameTypes`);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };
}

export default LookupService;
